import React from "react";
import MultiLine from "../../ui/chart/MultiLine";
import MultiLine2 from "../../ui/chart/MultiLine";
import Pie from "../../ui/chart/Pie"
import Pie2 from "../../ui/chart/Pie"
import Pie3 from "../../ui/chart/Pie"
import { Button, Row, Col, DatePicker, Select,Statistic } from "antd";
import moment from "moment";
import http from "../../../axios/http";
import { EchartBar } from './EchartBar';
const { RangePicker } = DatePicker;


class MallStockAnalysis extends React.Component {
  state = {
    dates: [],
    nums:[],
    dateNums:[],
    resBrandData: [],
    currentBrand:"",
    //成交数据
    dealDates:[],
    dealNums:[],
    dealDateNums:[],
    dealResBrandData: [],
    dealCurrentBrand:""
  };

  componentWillMount() {
    this.setState({
      start: moment().subtract(1, "days").format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),
      dealDate:moment().subtract(5, "days").format("YYYY-MM-DD")
    });
    this.loadStockData();
    this.loadDealData();
  }
  //加载库存数据
  loadStockData() {
    let param={
      oldDate:this.state.start
    }

    http.post({
      url: "/mall/analysis/stock",
      data: param,
      success: (res) => {
        let dates=res.dates;
        let title='主楼在库车数';
        //在库数量
        let numData={
          area:{},
          data:res.nums,
          text:title
        }
        var dateNums = [];
        dateNums.push(numData);
        //新能源车占比
        let pieData=[
          {
            value: res.newEnergyNum,
            name: '新能源'
          },
          {
            value: res.totalNum-res.newEnergyNum,
            name: '汽油'
          }
        ]
        //品牌排行
        let resBrandData= res.brand;
        let brandNumList=[];
        let brandList=[];

        for (let i = 0; i < resBrandData.length&&i < 16; i++) {
          if(resBrandData[i].brand!=null){
            brandNumList.push(resBrandData[i].count);
            brandList.push(resBrandData[i].brand);
          }
        }
        let brandData = this.getChartData('品牌排行', 'bar', brandNumList, 'brandDataBar', brandList,"个");
        // let modelData = this.getChartData('型号排行', 'bar', modelNumList, 'brandDataBar', modelList, "个");
        if(brandList.length>1){
          this.loadStockModel(brandList[0]);
        }
        let currentBrand=brandList[0];
        let nums=res.nums
        this.setState({ nums,dates,
          dateNums,
          pieData,
          brandData,
          resBrandData,
          currentBrand});
        this.state.initChartBar1();
      },
    });
  }
  //查库存车车型
  loadStockModel(brand){
    http.post({
      url: "/mall/analysis/model",
      data: {brand:brand},
      success: (res) => {
        if(res.length>1){
          let modelNumList=[];
          let modelList=[];

          for (let i = 0; i<res.length&&i<16; i++) {
            if(i<16){
              modelNumList.push(res[i].count);
              modelList.push(res[i].model);
            }
          }
          let modelData = this.getChartData('型号排行', 'bar', modelNumList, 'modelDataBar', modelList,"个");
          this.setState({ modelData});
          this.state.initChartBar2();
        }
      }
    })
  }

  loadDealData() {
    let param={
      oldDate:this.state.dealDate
    }

    http.post({
      url: "/mall/analysis/deal",
      data: param,
      success: (res) => {
        let dealDates=res.dates;
        let title='主楼交易车数';
        // //交易数量
        let dealNumData={
          area:{},
          data:res.nums,
          text:title
        }
        var dealDateNums = [];
        dealDateNums.push(dealNumData);
        // //新能源车占比
        let dealPieData=[
          {
            value: res.newEnergyNum,
            name: '新能源'
          },
          {
            value: res.totalNum-res.newEnergyNum,
            name: '汽油'
          }
        ]
        // //品牌排行
        let resBrandData= res.brand;
        let brandNumList=[];
        let brandList=[];

        for (let i = 0; i < resBrandData.length&&i < 16; i++) {
          if(resBrandData[i].brand!=null){
            brandNumList.push(resBrandData[i].count);
            brandList.push(resBrandData[i].brand);
          }
        }
        let brandData = this.getChartData('交易品牌排行', 'bar', brandNumList, 'brandDataBar', brandList,"个");
        if(brandList.length>1){
          this.loadDealModel(brandList[0]);
        }
        let currentBrand=brandList[0];
        let dealNums=res.nums
        this.setState({
          dealNums:dealNums,
          dealDates:dealDates,
          dealDateNums:dealDateNums,
          dealPieData:dealPieData,
          dealBrandData:brandData,
          dealResBrandData:resBrandData,
          dealCurrentBrand:currentBrand
        });
        this.state.initChartBar3();
      },
    });
  }

  //查库存车车型
  loadDealModel(brand){
    http.post({
      url: "/mall/analysis/dealModel",
      data: {brand:brand},
      success: (res) => {
        if(res.length>0){
          let modelNumList=[];
          let modelList=[];

          for (let i = 0; i<res.length&&i<16; i++) {
            if(i<16){
              modelNumList.push(res[i].count);
              modelList.push(res[i].model);
            }
          }
          let modelData = this.getChartData('成交型号排行', 'bar', modelNumList, 'dealModelDataBar', modelList,"个");
          this.setState({ 
            dealModelData:modelData
          });
          this.state.initChartBar4();
        }
      }
    })
  }

  getChartData = (name, type, rateList, id, xSeries, unit) => {
    let getData = [
        {
            name: name,
            type: type,
            data: rateList,
            itemStyle: {
                normal: {
                    color: '#0096f3'
                }
            },
            areaStyle: {},  // 折线下阴影背景
            label: {
                normal: {
                    show: true,
                    position: 'top'
                }
            },

        }
    ];
    let optionData = {
        listData: getData,
        id: id,
        xSeries: xSeries,
        areaStyle: {},
        unit: unit
    };
    return optionData;
}

selectChange = (field, value) => {
  this.loadStockModel(this.state.resBrandData[value].brand)
}
selectChange1 = (field, value) => {
  this.loadDealModel(this.state.dealResBrandData[value].brand)
}

  periodChange = (val, valstr) => {
    console.log("periodChange", valstr);
    this.setState({ start: valstr[0], end: valstr[1] });
    this.loadStockData();
    setTimeout(() => {
      this.loadStockData();
    }, 500);
  };

  render() {
    var dateFormat = "YYYY-MM-DD";
    var {nums,dateNums,dates,pieData,start,end,dealNums,dealDateNums,dealDates,dealPieData} = this.state;
    //库存车铜币
    let rate = 0;
    if (nums[0] !== "0") {
        rate = ((nums[nums.length-1])* 100/ nums[0]).toFixed(2) + "%";
    }
    //成交数同比
    let dealRate=0;
    if (dealNums[0] !== "0") {
      dealRate = ((dealNums[dealNums.length-1])* 100/ dealNums[0]).toFixed(4) + "%";
    }
    return (
      <div style={{ width: "100%", height: "100%", overflow: "auto" }}>
        <Row>
          <Col span={24} style={{ textAlign: "left" }}>
            <RangePicker
              defaultValue={[moment(start), moment(end)]}
              onChange={this.periodChange}
              format={dateFormat}
              disabled={true}
              allowClear={false}
            />{" "}
            &nbsp;
            <Button type="primary" onClick={this.loadStockData.bind(this)}>
              查询
            </Button>
          </Col>
        </Row>
        {/* 库存统计 */}
        <div className="berth-head" key="hede">
          <Row>
            <Col span={3} className="head-statistic">
              <Statistic title="在库车数环比" value={rate} />
            </Col>
          </Row>
        </div>
        {/* 库存数柱图 */}
        <Row>
          <Col span={24}>
            <MultiLine
              key="stock"
              title="在库车数环比"
              data={dateNums}
              xData={dates}
              yNames={["主楼车数(辆)"]}
              height="400px"
              refreshChart={(func) => {
                this.setState({ refreshChart: func });
              }}
            ></MultiLine>
          </Col>
        </Row>
            
        <Row>
          <Col span={24} style={{height: 400}}>
            <Pie 
              key="newEnergy"
              title="在库新能源车占比"
              legendShow={false}
              data={pieData}
              labelShow={true}
              refreshChart={(func) => {
                this.setState({ refreshPie: func });
              }}
            ></Pie>
          </Col>
        </Row>
        <div style={{ width: '100%', marginTop: '40px', overflow: 'hidden' }}>
          {
            this.state.brandData ? 
            <div style={{ width: '100%', height: '400px' }}>
              <EchartBar
                  echartId={this.state.brandData.id}
                  title={'品牌排行'}
                  echartData={this.state.brandData}
                  initChart={(func) => { this.setState({ initChartBar1: func }) }}
              />
            </div>:''
          }
        </div>
        {this.state.modelData ?<Row>
          <Col span={24} style={{ textAlign: "left" }}>
            <Select placeholder="品牌" onChange={this.selectChange.bind(this, "brandName")} defaultValue={this.state.currentBrand} style={{ width: 200, marginRight: "10px" }}>
              {this.state.resBrandData.map(d =>
                  <Select.Option key={d["id"]}>{d["brand"]}</Select.Option>
              )}
            </Select>
          </Col>
        </Row>:''}
        {/* 车型排行 */}
        <div style={{ width: '100%', marginTop: '40px', overflow: 'hidden' }}>
          {
            this.state.modelData ? <div style={{ width: '100%', height: '400px' }}>
              <EchartBar
                  echartId={this.state.modelData.id}
                  title={'车型排行'}
                  echartData={this.state.modelData}
                  initChart={(func) => { this.setState({ initChartBar2: func }) }}
              />
            </div>:''
          }
        </div>
        {/* 成交数据 */}
        {/* 成交环比 */}
        <div >
          <Row>
            <Col span={3} className="head-statistic">
              <Statistic title="成交数环比" value={dealRate} />
            </Col>
          </Row>
        </div>
        {/* 成交数柱图 */}
        <Row>
          <Col span={24}>
            <MultiLine2
              key="deal"
              title="成交数环比"
              data={dealDateNums}
              xData={dealDates}
              yNames={["主楼车数(辆)"]}
              height="400px"
              refreshChart={(func) => {
                this.setState({ refreshChart2: func });
              }}
            ></MultiLine2>
          </Col>
        </Row>
        <Row>
          <Col span={12} style={{height: 400}}>
            <Pie2 
              key="dealNewEnergy"
              title="成交新能源车占比"
              legendShow={true}
              data={dealPieData}
              labelShow={true}
              refreshChart={(func) => {
                this.setState({ refreshPie2: func });
              }}
            ></Pie2>
          </Col>
          <Col span={12} style={{height: 400}}>
            <Pie3 
              key="dealNewEnergy2"
              title="成交新能源车占比"
              legendShow={true}
              data={dealPieData}
              labelShow={true}
              refreshChart={(func) => {
                this.setState({ refreshPie3: func });
              }}
            ></Pie3>
          </Col>
        </Row>
        {/* 成交品牌排行 */}
        <div style={{ width: '100%', marginTop: '40px', overflow: 'hidden' }}>
          {
            this.state.dealBrandData ? 
            <div style={{ width: '100%', height: '400px' }}>
              <EchartBar
                  echartId={this.state.dealBrandData.id}
                  title={'成交品牌排行'}
                  echartData={this.state.dealBrandData}
                  initChart={(func) => { this.setState({ initChartBar3: func }) }}
              />
            </div>:''
          }
        </div>
        {/* 成交品牌下拉选 */}
        {this.state.dealModelData ?<Row>
          <Col span={24} style={{ textAlign: "left" }}>
            <Select placeholder="品牌" onChange={this.selectChange1.bind(this, "brandName")} defaultValue={this.state.dealCurrentBrand} style={{ width: 200, marginRight: "10px" }}>
              {this.state.dealResBrandData.map(d =>
                  <Select.Option key={d["id"]}>{d["brand"]}</Select.Option>
              )}
            </Select>
          </Col>
        </Row>:''}
        {/* 成交型号 */}
        <div style={{ width: '100%', marginTop: '40px', overflow: 'hidden' }}>
          {
            this.state.dealModelData ? <div style={{ width: '100%', height: '400px' }}>
              <EchartBar
                  echartId={this.state.dealModelData.id}
                  title={'成交车型排行'}
                  echartData={this.state.dealModelData}
                  initChart={(func) => { this.setState({ initChartBar4: func }) }}
              />
            </div>:''
          }
        </div>
      </div>
    );
  }
}

export default MallStockAnalysis;
